import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitSimCancelledModel } from '@apps-common/types/management/unit'

export const QUERY_MANAGEMENT_GET_UNIT_CANCELLED = (unitId: string) => ['getUnitCancelled', unitId]

export const getUnitCancelled = async (unitId: string): Promise<IUnitSimCancelledModel> =>
  axios.get(`/management/unit/getcancelledunit?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitCancelled

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useManagementGetUnitCancelled = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    staleTime: 0,
    queryKey: QUERY_MANAGEMENT_GET_UNIT_CANCELLED(unitId),
    queryFn: () => getUnitCancelled(unitId)
  })
